import { dateDiff } from '@/business/utils/dates';

const getRequestsByState = (requests, statuses) =>
  requests.filter(
    (request) => request.rejected === 'N' && statuses.includes(request.status)
  );

export function countRequestStates(requests) {
  return ['1', '2', '3', '5'].map((status) => ({
    status,
    count: getRequestsByState(requests, [status]).length,
  }));
}

export function getAllRequestStates(requests) {
  return getRequestsByState(requests, ['1', '2', '3', '5']);
}

export function getRecentRequests(requests, days) {
  const now = new Date();
  return requests.filter(
    (request) => dateDiff(request.signalisation_datetime, now).day < days
  );
}

export function groupbySymptom(requests) {
  return requests
    .reduce((acc, request) => {
      const val = request.work_order_group_type_code;
      if (acc.some((item) => item.code === val)) {
        return acc.map((item) =>
          item.code === val ? { ...item, count: item.count + 1 } : item
        );
      }
      return acc.concat({
        code: val,
        name: request.work_order_group_type_name,
        count: 1,
      });
    }, [])
    .sort((a, b) => a.name.localeCompare(b.name));
}

function getCustomer(request) {
  if (request.customer_civility === '1') {
    return `Mr ${request.customer_name} ${
      request.customer_phone ? `: ${request.customer_phone}` : ''
    }`;
  }
  if (request.customer_civility === '2') {
    return `Mme ${request.customer_name} ${
      request.customer_phone ? `: ${request.customer_phone}` : ''
    }`;
  }
  return `${request.customer_name} ${
    request.customer_phone ? `: ${request.customer_phone}` : ''
  }`;
}

export function groupbyCustomer(requests) {
  return requests
    .reduce((acc, request) => {
      const val = getCustomer(request);
      if (acc.some((item) => item.name === val)) {
        return acc.map((item) =>
          item.name === val ? { ...item, count: item.count + 1 } : item
        );
      }
      return acc.concat({
        name: val,
        lastName: request.customer_name,
        phone: request.customer_phone,
        civility: request.customer_civility,
        count: 1,
      });
    }, [])
    .filter((item) => item.count > 1)
    .sort((a, b) => a.lastName.localeCompare(b.lastName));
}

const getFinishedAndRejectedType = (request) => {
  const rejected = request.rejected === 'O';
  return {
    rejected,
    status: rejected ? null : request.status,
  };
};

export function getFinishedAndRejected(requests) {
  return requests.filter(
    (request) =>
      request.rejected === 'O' ||
      request.status === '5' ||
      request.status === '9'
  );
}

export function sortFinishedAndRejected(requests) {
  return requests
    .reduce((acc, request) => {
      const val = getFinishedAndRejectedType(request);
      if (
        acc.some(
          (item) => item.rejected === val.rejected && item.status === val.status
        )
      ) {
        return acc.map((item) =>
          item.rejected === val.rejected && item.status === val.status
            ? { ...item, list: item.list.concat(request) }
            : item
        );
      }
      return acc.concat({
        ...val,
        list: [request],
      });
    }, [])
    .sort((a, b) => {
      if (a.rejected) {
        return 1;
      }
      if (b.rejected) {
        return -1;
      }
      return a.status.localeCompare(b.status);
    });
}

export function sortByReason(requests) {
  return requests
    .reduce(
      (acc, request) =>
        acc.some((item) => item.reason === request.reason_to_be_continued)
          ? acc.map((item) =>
              item.reason === request.reason_to_be_continued
                ? { ...item, list: item.list.concat(request) }
                : item
            )
          : acc.concat({
              reason: request.reason_to_be_continued,
              list: [request],
            }),
      []
    )
    .sort((a, b) => {
      if (!a.reason) {
        return -1;
      }
      if (!b.reason) {
        return 1;
      }
      return 0;
    });
}
